import { Link } from "react-router-dom";
import { ArrowRight, Clock } from "lucide-react";
import { blogPosts } from "@/data/blogPosts";
import { SectionHeading, Reveal } from "@/components/motion";

export const BlogCard = ({ post, index = 0 }) => (
  <Reveal delay={index % 3}>
    <Link
      to={`/blog/${post.slug}`}
      data-testid={`blog-card-${post.slug}`}
      className="group flex flex-col h-full bg-white rounded-2xl border border-slate-200/80 shadow-soft p-6 sm:p-7 hover:-translate-y-1 hover:shadow-lift hover:border-teal-500/30 transition-[transform,box-shadow,border-color] duration-300"
    >
      <div className="flex items-center justify-between gap-3">
        <span className="text-[11px] font-mono uppercase tracking-wider text-teal-700 bg-teal-50 border border-teal-100 rounded-full px-3 py-1">
          {post.category}
        </span>
        <span className="inline-flex items-center gap-1 text-xs text-slate-400">
          <Clock size={12} /> {post.readTime}
        </span>
      </div>
      <h3 className="mt-4 font-serif font-semibold text-slate-900 text-xl leading-snug group-hover:text-navy-700 transition-colors">
        {post.title}
      </h3>
      <p className="mt-2.5 text-sm text-slate-600 leading-relaxed flex-1">{post.excerpt}</p>
      <span className="mt-5 inline-flex items-center gap-1.5 text-sm font-semibold text-teal-700">
        Read article
        <ArrowRight size={15} className="group-hover:translate-x-1 transition-transform duration-200" />
      </span>
    </Link>
  </Reveal>
);

export const BlogSection = () => (
  <section id="blog" className="bg-white border-y border-slate-200/70 py-16 sm:py-24 lg:py-32" data-testid="blog-section">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-6">
        <SectionHeading
          number="09"
          eyebrow="Health Blog"
          title="Medical Articles for Patients"
          sub="Medically responsible, easy-to-read articles on common health concerns — written for patient education."
        />
        <Reveal delay={2} className="shrink-0">
          <Link
            to="/blog"
            data-testid="blog-view-all-link"
            className="inline-flex items-center gap-2 text-sm font-semibold text-navy-900 hover:text-teal-700 transition-colors"
          >
            View all articles <ArrowRight size={15} />
          </Link>
        </Reveal>
      </div>
      <div className="mt-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-testid="blog-grid">
        {blogPosts.slice(0, 6).map((post, i) => (
          <BlogCard key={post.slug} post={post} index={i} />
        ))}
      </div>
    </div>
  </section>
);
